import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const commonErr = "OOPS! something went wrong!";

const toastQueue: any = [];
let isShowingToast = false;

export const showAlert = (type: any, message = commonErr) => {
  const showNextToast = () => {
    if (toastQueue.length > 0 && !isShowingToast) {
      isShowingToast = true;
      const { type, message } = toastQueue.shift();

      const onClose = () => {
        isShowingToast = false;
        showNextToast();
      };

      switch (type) {
        case 1:
          toast.success(message, {
            onClose,
            icon: false,
            className:
              ".Toastify__toast--success toast-info-container toast-info-container-after",
            position: "top-right",
            autoClose: 3000,
            draggable: false,
            closeOnClick: true,
          });
          break;
        case 2:
          toast.error(message, {
            onClose,
            className:
              ".Toastify__toast--error toast-info-container toast-info-container-after",
            position: "top-right",
            icon: false,
            autoClose: 3000,
            draggable: false,
            closeOnClick: true,
          });
          break;
        case 3:
          toast.info(message, {
            onClose,
            position: "top-right",
            autoClose: 3000,
            draggable: false,
            closeOnClick: true,
          });
          break;
        case 4:
          toast.dark(message, {
            onClose,
            className: "hide-alert",
            position: "top-right",
            autoClose: 3000,
            draggable: false,
            closeOnClick: true,
          });
          break;
        case 5:
          toast.error(message, {
            onClose,
            className:
              ".Toastify__toast--error toast-info-container toast-info-container-after",
            position: "top-right",
            icon: false,
            autoClose: 3000,
            draggable: false,
            closeOnClick: true,
          });
          break;
        default:
          toast(message, {
            onClose,
            position: "top-right",
            autoClose: 3000,
            draggable: false,
            closeOnClick: true,
          });
      }
    }
  };

  toastQueue.push({ type, message });
  showNextToast();
};
